var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-form',{ref:"dataForm",staticClass:"demo-form-inline",attrs:{"model":_vm.form,"rules":_vm.rules}},[_c('el-form-item',{attrs:{"prop":"paraTextForWeb"}},[_c('div',{attrs:{"id":"J_quillEditor"}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }